import * as Roboto from "@remotion/google-fonts/Roboto";
import * as OpenSans from "@remotion/google-fonts/OpenSans";
import * as Lato from "@remotion/google-fonts/Lato";
import * as Poppins from "@remotion/google-fonts/Poppins";
import * as Montserrat from "@remotion/google-fonts/Montserrat";
import * as Merriweather from "@remotion/google-fonts/Merriweather";
import * as PlayfairDisplay from "@remotion/google-fonts/PlayfairDisplay";
import * as Lora from "@remotion/google-fonts/Lora";
import * as NotoSerif from "@remotion/google-fonts/NotoSerif";
import * as Pacifico from "@remotion/google-fonts/Pacifico";
import * as DancingScript from "@remotion/google-fonts/DancingScript";
import * as Lobster from "@remotion/google-fonts/Lobster";

const loadedFonts = new Set<string>();

// Define a type for font modules
type FontModule = {
  loadFont: () => void;
};

const FONT_MODULES: Record<string, FontModule> = {
  Roboto: Roboto,
  "Open Sans": OpenSans,
  Lato: Lato,
  Poppins: Poppins,
  Montserrat: Montserrat,
  Merriweather: Merriweather,
  "Playfair Display": PlayfairDisplay,
  Lora: Lora,
  "Noto Serif": NotoSerif,
  Pacifico: Pacifico,
  "Dancing Script": DancingScript,
  Lobster: Lobster,
};

export const AVAILABLE_FONTS = Object.keys(FONT_MODULES);

type FontFamily = keyof typeof FONT_MODULES;

export const loadFont = async (fontFamily: FontFamily): Promise<boolean> => {
  if (loadedFonts.has(fontFamily)) {
    return true;
  }

  const fontModule = FONT_MODULES[fontFamily];
  if (!fontModule) {
    console.warn(`Font ${fontFamily} is not available in the specified list.`);
    return false;
  }

  try {
    fontModule.loadFont();
    loadedFonts.add(fontFamily);
    return true;
  } catch (e) {
    console.warn(`Failed to load font ${fontFamily}:`, e);
    return false;
  }
};
